import React, { useCallback, useContext } from "react";
import { withRouter, Redirect } from "react-router";
import firebase from "../config/firebase.js";
import { AuthContext } from "../Auth.js";

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';


function Copyright() {
  return (
    <>
      <Typography variant="body2" color="textSecondary" align="center">
        <Link color="inherit">
          Unidos para Ayudar
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
      <Typography variant="caption" color="inherit" align="center">
        0.6.10
      </Typography>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));


const Reset = ({ history }) => {

  const classes = useStyles();

  const sendPasswordReset = (event) => {
    event.preventDefault();
    const { email } = event.target.elements;

    var actionCodeSettings = {
       url: "https://unidosparaayudar.web.app/login",
    };
    firebase.auth().sendPasswordResetEmail(
        email.value, actionCodeSettings)
    .then(function() {
      alert("Gracias, si los datos son correctos te llegará un correo para restablecer a la brevedad")
    })
    .catch(function(error) {
      alert("Ocurrió un error, no se a podido reestablecer")
      console.log(error)
    });
  }

  const { currentUser } = useContext(AuthContext);

  if (currentUser) {
    return <Redirect to="/" />;
  }
   
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5" align="center">
          Solicitar nueva contraseña<br/>
          Unidos para Ayudar
        </Typography>
        <form className={classes.form} noValidate onSubmit={sendPasswordReset}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="cedula"
            label="Cedula"
            type="text"
            id="cedula"
            autoComplete="cedula"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Reestablecer
          </Button>
          <Grid container>
            <Grid item xs>
            <Link href="/login" variant="body2">
                {"Si tenés cuenta, ingresá"}
              </Link>
            </Grid>
            <Grid item>
              <Link href="/signup" variant="body2">
                {"Si no tenés cuenta, registrate"}
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default withRouter(Reset);